export default {"src":"/login-app/[GIT_HASH]/_next/static/media/gantt_waterfall.55137f26.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};